module.exports = __webpack_public_path__ + "static/media/nav-signing-red.afdd01cc.svg";